import dj from "dayjs"

let cacheMap = {
  demo: {
    promise: Promise.resolve("demo"), // 请求promise
    expireAt: dj()
  }
}
window._cacheMap = cacheMap

/**
 * 通用缓存
 * @param key 缓存键
 * @param reqFunc 请求函数
 * @param timeout 单位秒(默认30分钟)
 * @returns Promise
 */
export function getCachedObj({ key, reqFunc, timeout = 60 * 30 }) {
  // 已经请求过
  if (cacheMap[key]) {
    if (
      !cacheMap[key].expireAt || // 第一个请求还没有结束,直接返回请求中的promise
      cacheMap[key].expireAt.isAfter(dj()) // 请求已完成,且未过期,返回缓存的结果
    ) {
      return cacheMap[key].promise
    }
  }
  // 发起请求
  cacheMap[key] = {
    promise: reqFunc()
      .then(res => {
        cacheMap[key].expireAt = dj().add(timeout, "second")
        return res
      })
      .catch(err => {
        delete cacheMap[key]
        return Promise.reject(err)
      })
  }
  return cacheMap[key].promise
}

export function removeCache(key) {
  delete cacheMap[key]
}
